export const useMenuState = () => useState("menu-state", () => "collapsed");
